import * as React from 'react';

import { CustomIconProps, defaultIconProps } from './types';

export function PencilIcon({
  size = defaultIconProps.size,
  color = '#0000A3',
  className,
  ...props
}: CustomIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21.006 7.252L16.81 3.057a1.481 1.481 0 00-1.064-.432 1.49 1.49 0 00-1.055.444L3.434 14.327A1.48 1.48 0 003 15.381v4.193c0 .828.674 1.501 1.5 1.501h4.197c.39 0 .774-.158 1.053-.435L21.018 9.37c.581-.59.574-1.542-.012-2.118zM8.693 19.574H4.5l-.004-4.187 8.261-8.257 4.189 4.189-8.254 8.255zm9.315-9.315L13.82 6.07l1.94-1.94 4.185 4.192-1.937 1.936z"
        fill={color}
      />
    </svg>
  );
}

export default PencilIcon;
